'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildChatHeadingConfigFromJS = undefined;

var _buildChatHeadingConfig = require('./buildChatHeadingConfig');

var _buildDefaultChatHeadingConfig = require('./buildDefaultChatHeadingConfig');

var buildChatHeadingConfigFromJS = exports.buildChatHeadingConfigFromJS = function buildChatHeadingConfigFromJS(payload) {
  if (!payload) {
    return (0, _buildDefaultChatHeadingConfig.buildDefaultChatHeadingConfig)();
  }
  return (0, _buildChatHeadingConfig.buildChatHeadingConfig)(payload);
};